import { render, staticRenderFns } from "./ApiDownloads.vue?vue&type=template&id=f7f96c6a&"
import script from "./ApiDownloads.vue?vue&type=script&lang=js&"
export * from "./ApiDownloads.vue?vue&type=script&lang=js&"
import style0 from "./ApiDownloads.vue?vue&type=style&index=0&id=f7f96c6a&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f7f96c6a')) {
      api.createRecord('f7f96c6a', component.options)
    } else {
      api.reload('f7f96c6a', component.options)
    }
    module.hot.accept("./ApiDownloads.vue?vue&type=template&id=f7f96c6a&", function () {
      api.rerender('f7f96c6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-api/components/ApiDownloads.vue"
export default component.exports